import {
  createRouter,
  createRootRoute,
  createRoute,
  redirect,
} from "@tanstack/react-router";
import { Layout } from "~/components/Layout/Layout";
import { SwapPage } from "~/pages/swap";
import { StatusPage } from "~/pages/status";

const rootRoute = createRootRoute({ component: Layout });

const swapRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/swap",
  component: SwapPage,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/swap" });
  },
});

const statusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/status/$txHash",
  component: StatusPage,
});

const routeTree = rootRoute.addChildren([indexRoute, swapRoute, statusRoute]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
